/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateWorkItemRequestDto { 
    /**
     * Work item title
     */
    title?: string;
    /**
     * Detailed description
     */
    description?: string;
    /**
     * Rich text content for frontend display
     */
    content?: string;
    /**
     * Priority level
     */
    priority?: UpdateWorkItemRequestDto.PriorityEnum;
    /**
     * Due date for work item completion
     */
    dueDate?: string;
    /**
     * Custom metadata for the work item
     */
    metadata?: any;
}
export namespace UpdateWorkItemRequestDto {
    export type PriorityEnum = 'low' | 'medium' | 'high' | 'urgent';
    export const PriorityEnum = {
        Low: 'low' as PriorityEnum,
        Medium: 'medium' as PriorityEnum,
        High: 'high' as PriorityEnum,
        Urgent: 'urgent' as PriorityEnum
    };
}


